/* ═══════════════════════════════════════════════════════
   SOFTLINE PRODUCT PAGE – JavaScript
   FAQ accordion, sticky CTA, scroll animations
═══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── FAQ ACCORDION ──────────────────────────────────── */
  document.querySelectorAll('#sl-product-extras .sp-faq-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.sp-faq-item');
      var wasOpen = item.classList.contains('sp-open');

      // Close all
      document.querySelectorAll('#sl-product-extras .sp-faq-item').forEach(function (el) {
        el.classList.remove('sp-open');
      });

      // Toggle clicked
      if (!wasOpen) {
        item.classList.add('sp-open');
      }
    });
  });

  /* ── STICKY ADD-TO-CART ─────────────────────────────── */
  var stickyBar = document.querySelector('#sl-product-extras .sp-sticky-atc');
  if (stickyBar) {
    var productInfo = document.querySelector('.product__info-wrapper') || document.querySelector('product-info');
    var showThreshold = 600;

    function checkStickyVisibility() {
      var scrollY = window.scrollY || window.pageYOffset;
      if (scrollY > showThreshold) {
        stickyBar.classList.add('sp-visible');
      } else {
        stickyBar.classList.remove('sp-visible');
      }
    }

    window.addEventListener('scroll', checkStickyVisibility, { passive: true });
    checkStickyVisibility();
  }

  /* ── SCROLL ANIMATIONS ──────────────────────────────── */
  var animateElements = document.querySelectorAll('#sl-product-extras .sp-animate');
  if (animateElements.length > 0 && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sp-visible-anim');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    animateElements.forEach(function (el) { observer.observe(el); });
  } else {
    // Fallback: just show them
    animateElements.forEach(function (el) { el.classList.add('sp-visible-anim'); });
  }

  /* ── STICKY ATC BUTTON – Scroll to form ─────────────── */
  var stickyBtn = document.querySelector('#sl-product-extras .sp-sticky-btn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var buyBtn = document.querySelector('.product-form__submit') || document.querySelector('[name="add"]');
      if (buyBtn) {
        buyBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { buyBtn.click(); }, 600);
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

})();
